import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/notepad.svg'
import _imports_1 from '@/assets/images/ws-creation-success-image.png'


const _withScopeId = n => (_pushScopeId("data-v-abb0c240"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "estimate-received-preview tw-h-full tw-w-full tw-flex tw-flex-col tw-gap-4" }
const _hoisted_2 = { class: "estimate-received-preview__container tw-flex tw-items-start tw-justify-between tw-py-4 tw-box-border tw-border-[0] tw-border-b-[1px] tw-border-[#C5D2F2] tw-border-solid" }
const _hoisted_3 = { class: "tw-flex tw-items-center tw-gap-4 lg:tw-hidden" }
const _hoisted_4 = {
  key: 0,
  class: "tw-gap-10 tw-flex xl:tw-gap-5 2xl:tw-flex-col"
}
const _hoisted_5 = { class: "tw-flex tw-flex-col tw-gap-4 tw-w-[340px] tw-max-w-full lg:tw-w-full" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-4 tw-items-start" }
const _hoisted_7 = { class: "lg:tw-flex tw-items-center tw-gap-4 tw-hidden sm:tw-flex-col" }
const _hoisted_8 = { class: "tw-pb-2 tw-box-border tw-flex tw-flex-col tw-gap-4 tw-w-[calc(100%_-_380px)] tw-max-w-full 2xl:tw-w-full lg:tw-pr-0 lg:tw-pl-0" }
const _hoisted_9 = { class: "tw-flex tw-flex-col tw-gap-2 tw-w-full" }
const _hoisted_10 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start" }
const _hoisted_11 = { class: "tw-w-full tw-flex tw-items-center tw-justify-start tw-gap-8" }
const _hoisted_12 = {
  key: 0,
  class: "tw-bg-white tw-rounded-lg tw-px-4 tw-py-5 tw-shadow-[0px_0px_8px_0px_#0C0F4A14] tw-text-darkBlue tw-text-left"
}
const _hoisted_13 = { class: "tw-flex tw-gap-y-4 tw-gap-x-6 rmd:tw-gap-x-16 tw-flex-wrap" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Emergency call out fee")
], -1))
const _hoisted_15 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Emergency call out rate")
], -1))
const _hoisted_17 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tw-text-[12px] tw-font-bold tw-tracking-[0.15px]" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Contractor Note")
], -1))
const _hoisted_19 = { class: "tw-tracking-[0.25px] tw-text-[10px] tw-mt-1" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "estimate_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_22 = { class: "estimate_text" }
const _hoisted_23 = { class: "estimate_footer" }
const _hoisted_24 = { class: "modal_wrapper" }
const _hoisted_25 = { class: "main" }
const _hoisted_26 = { class: "content-loader" }
const _hoisted_27 = { class: "switching-text" }
const _hoisted_28 = { class: "loading-dots" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "loader__footer" }
const _hoisted_31 = { class: "modal__text" }
const _hoisted_32 = { class: "header-title" }
const _hoisted_33 = { class: "tw-ml-2 !tw-capitalize" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-sub-title" }, " You have successfully Raise a Project ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "custom__modal__img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "Accept Raise Project"
  })
], -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iste corporis est a. Temporibus reiciendis tempora quisquam? ", -1))

import { computed, ref, onBeforeMount } from "vue";
import GeneralDialog from "@/core/components/modals/GeneralDialog.vue";
import BackButton from "@/core/components/common/BackButton.vue";
import Button from "@/core/components/ui/general/Button.vue";
import Text from "@/core/components/ui/general/Text.vue";
import ContractorDetailsCard from "@/modules/project/components/common/ContractorDetailsCard.vue";
import LabelWithValue from "@/core/components/common/LabelWithValue.vue";
import EstimateReceivedSummaryCard from "@/modules/project/components/common/EstimateReceivedSummaryCard.vue";
import CommercialChip from "@/core/uni-components/Chips/CommercialChip.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import CommonDialog from "@/core/components/CommonDialog.vue";
import JobService from "@/core/services/jobs.service";
import notificationService from "@/core/services/notification.service";
import { USER_STORE } from "@/store/modules/user";
import { PROJECT_ROUTE } from "../../routes";
import { ProjectMetaDataStatusEnum } from "@/core/enums";
import projectService from "@/core/services/project.service";
import { ProjectJobStatusEnum } from "@/core/enums/ProjectsEnum";
import ServiceAgreementModal from "@/modules/jobs/components/modal/ServiceAgreementModal.vue";
import EstimateApproveModal from "../../modal/EstimateApproveModal.vue";
import { AgreeTermsConsumerDisclosure } from "@/core/enums/estimateEnum";
import projectEstimationService from "@/core/services/project-estimation.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestedEstimateReceivedPreview',
  props: {
  estimateId: {
    type: Number,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const store = useStore();
const details = ref(null) as any;
const isAcceptEstimate = ref(false);
const isRejectEstimate = ref(false);
const isOpenServiceAgreementModal = ref(false);
const currentSelectedTab = ref({ name: "tab1" });
const emergencyCallOutDetails = ref(null) as any;
const isPostLoadingModal = ref(false);
const isFinalDialog = ref(false);
const switchingText = ref("Loading");
const switchingImage = ref("custom-loader.svg");
const tabListItems = ref([
  { name: "tab1" },
  { name: "tab2" },
  { name: "tab3" },
]);

const onCloseServiceAgreementModal = (active: boolean) => {
  isOpenServiceAgreementModal.value = !isOpenServiceAgreementModal.value;
  if (active) {
    showLoadingScreen();
  }
};
const projectEstimate = computed(() => {
  return {
    ...details.value,
    projectEstimateCreator: {
      ...contractorDetails.value?.user,
      workStation: details.value?.workStation,
    },
    projectStages: details.value?.estimationPhase,
  };
});
const projectDetail = computed(() => {
  return {
    ...details.value?.project,
    projectCreator: {
      firstName: contractorDetails.value?.user?.firstName,
      lastName: contractorDetails.value?.user?.lastName,
    },
  };
});

const contractorDetails = computed(() => {
  return details.value?.workStation;
});

const delay = (ms: any) => new Promise((resolve) => setTimeout(resolve, ms));

const showLoadingScreen = async () => {
  isOpenServiceAgreementModal.value = false;
  isPostLoadingModal.value = true;
  // First step: Wait for 1 second
  await delay(1000);
  currentSelectedTab.value = tabListItems.value[0];

  // Second step: Wait for 2 seconds
  await delay(2000);
  currentSelectedTab.value = tabListItems.value[1];

  // Third step: Wait for 5 seconds
  await delay(5000);
  currentSelectedTab.value = tabListItems.value[2];
  if (isPostLoadingModal.value) {
    await onConfirmEstimate();
    isFinalDialog.value = true;
  }
  isPostLoadingModal.value = false;
};
const showServiceAgreementModal = () => {
  isAcceptEstimate.value = false;
  isOpenServiceAgreementModal.value = true;
};

const cancelAcceptingProject = () => {
  isPostLoadingModal.value = false;
};

const onClickRejectEstimate = () => {
  isRejectEstimate.value = true;
};

const onClickAcceptEstimate = () => {
  isAcceptEstimate.value = true;
};

const onConfirmEstimate = async () => {
  isAcceptEstimate.value = false;
  try {
    await store.dispatch(`${PROJECT_STORE}/updateRaiseProjectStatus`, {
      projectId: details.value?.project.id,
      data: {
        status: ProjectMetaDataStatusEnum.ACCEPTED,
      },
    });

    const payload = { status: AgreeTermsConsumerDisclosure.ACCEPTED };
    (await projectEstimationService.submitStatusWithEstimateUpdate(
      details.value?.project.id,
      details.value?.id,
      payload
    )) as any;

    (await projectEstimationService.submitStatusWithEstimateUpdate(
      details.value?.project.id,
      details.value?.id,
      { status: AgreeTermsConsumerDisclosure.SECURE_PROJECT_ESCROW }
    )) as any;

    resetNotification();
  } catch (error) {
    console.log("error", error);
  }
};

const resetNotification = async () => {
  store.commit(`${USER_STORE}/resetUserNotifications`);
  const userNotifications =
    (await notificationService.getUserNotificationStatus()) as any;
  userNotifications.forEach((userNotification: object) => {
    store.commit(`${USER_STORE}/setUserNotifications`, userNotification);
  });
};

const onCloseRejectEstimate = () => {
  isRejectEstimate.value = false;
};

const onCloseAcceptEstimate = () => {
  isAcceptEstimate.value = false;
};

const onConfirmRejectEstimate = async () => {
  await store.dispatch(`${PROJECT_STORE}/updateRaiseProjectStatus`, {
    projectId: details.value?.project.id,
    data: {
      status: ProjectMetaDataStatusEnum.REJECTED,
    },
  });

  resetNotification();
  onBackToProjects(null);
};

const onClickBackEstimateButton = () => {
  router.go(-1);
};
const onBackToProjects = async (tabName: null | string) => {
  let selectedTabName = "requested-projects";
  if (tabName) {
    selectedTabName = tabName;
  }
  await store.dispatch(
    `${PROJECT_STORE}/setProjectRedirectTabName`,
    selectedTabName
  );
  router.push({ name: PROJECT_ROUTE });
};
onBeforeMount(async () => {
  details.value = await store.dispatch(
    `${TRADE_ESTIMATE_STORE}/setTradeEstimateDetails`,
    {
      projectEstimateId: props.estimateId,
    }
  );
  if (!details.value) {
    onBackToProjects(null);
  }

  emergencyCallOutDetails.value =
    await JobService.getEmergencyJobCallOutDetails(details.value?.project?.id);
});

return (_ctx: any,_cache: any) => {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_stepper_item = _resolveComponent("v-stepper-item")!
  const _component_v_stepper_header = _resolveComponent("v-stepper-header")!
  const _component_v_stepper = _resolveComponent("v-stepper")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createVNode(BackButton, {
        label: "Back to Details",
        onClick: onClickBackEstimateButton
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Button, {
          class: "!tw-w-[200px]",
          variant: "secondary",
          label: "REJECT",
          onClick: onClickRejectEstimate
        }),
        _createVNode(Button, {
          class: "!tw-w-[200px]",
          label: "ACCEPT",
          onClick: onClickAcceptEstimate
        })
      ])
    ]),
    (details.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(ContractorDetailsCard, { contractorDetails: contractorDetails.value }, null, 8, ["contractorDetails"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(Button, {
              class: "!tw-w-[200px] sm:!tw-w-full",
              variant: "secondary",
              label: "REJECT",
              onClick: onClickRejectEstimate
            }),
            _createVNode(Button, {
              class: "!tw-w-[200px] sm:!tw-w-full",
              label: "ACCEPT",
              onClick: onClickAcceptEstimate
            })
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(Text, { variant: "h3" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(details.value?.project?.name), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(CommercialChip),
                _createVNode(LabelWithValue, {
                  justifyStart: true,
                  noBg: true,
                  data: details.value?.project?.refId,
                  label: "Project ID:"
                }, null, 8, ["data"])
              ])
            ]),
            _createVNode(_component_v_divider),
            (emergencyCallOutDetails.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _hoisted_14,
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", null, "£" + _toDisplayString(emergencyCallOutDetails.value.emergencyCallOutFee), 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", null, " £" + _toDisplayString(emergencyCallOutDetails.value.emergencyCallOutRate) + " / hour ", 1)
                      ])
                    ])
                  ]),
                  _createVNode(_component_v_divider, { class: "tw-my-3" }),
                  _createElementVNode("div", null, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("p", {
                        innerHTML: emergencyCallOutDetails.value.notes
                      }, null, 8, _hoisted_20)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(EstimateReceivedSummaryCard, { selectedEstimate: details.value }, null, 8, ["selectedEstimate"])
          ])
        ]))
      : _createCommentVNode("", true),
    (isAcceptEstimate.value || isRejectEstimate.value)
      ? (_openBlock(), _createBlock(GeneralDialog, {
          key: 1,
          width: "450px",
          maxWidth: "100%",
          isShowHeader: false,
          class: "project_accept_reject__modal",
          isShowCloseButton: false
        }, {
          body: _withCtx(() => [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h6", null, " Are you sure you want to " + _toDisplayString(isAcceptEstimate.value ? "Accept" : "Reject") + " this Raise the Project? ", 1)
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(Button, {
                variant: "tertiary",
                label: "cancel",
                class: "button button-purple-border",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (
              isAcceptEstimate.value
                ? onCloseAcceptEstimate()
                : onCloseRejectEstimate()
            ))
              }),
              _createVNode(Button, {
                label: isAcceptEstimate.value ? 'Accept' : 'Reject',
                class: "button button-orange",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
              isAcceptEstimate.value
                ? showServiceAgreementModal()
                : onConfirmRejectEstimate()
            ))
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      width: "390px",
      "max-width": "100%",
      modelValue: isPostLoadingModal.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isPostLoadingModal).value = $event)),
      class: "modal_box action-modal",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("main", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, _toDisplayString(switchingText.value), 1),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("img", {
                  class: "",
                  cover: "",
                  src: require('@/assets/icons/' + switchingImage.value)
                }, null, 8, _hoisted_29)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_component_v_stepper, {
                  class: "onboard-stepper",
                  modelValue: currentSelectedTab.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentSelectedTab.value.name) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_stepper_header, { class: "onboard-stepper__header" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabListItems.value, (step, index) => {
                          return (_openBlock(), _createBlock(_component_v_stepper_item, {
                            class: "onboard-stepper__item",
                            key: index,
                            value: step.name
                          }, null, 8, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_btn, {
                  class: "button button-orange",
                  onClick: cancelAcceptingProject,
                  width: "100%"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Cancel")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(CommonDialog, {
      modelValue: isFinalDialog.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((isFinalDialog).value = $event)),
      isShowHeader: false,
      isShowBackButton: false,
      width: "465px",
      "max-width": "100%",
      height: "auto",
      persistent: "",
      class: _normalizeClass(['succes_tradeowner_modal'])
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createTextVNode(" Great job, "),
            _createElementVNode("strong", _hoisted_33, _toDisplayString(details.value?.workStation?.name), 1)
          ]),
          _hoisted_34
        ]),
        _hoisted_35,
        _hoisted_36,
        _createVNode(_component_v_btn, {
          class: "button button-orange !tw-mt-[16px] rmd:!tw-mt-[24px]",
          size: "large",
          block: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (onBackToProjects('active-project')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" continue 🚀 ")
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (isOpenServiceAgreementModal.value)
      ? (_openBlock(), _createBlock(ServiceAgreementModal, {
          key: 2,
          project: projectDetail.value,
          projectEstimate: projectEstimate.value,
          type: "property",
          onOnConfirm: _cache[6] || (_cache[6] = ($event: any) => (onCloseServiceAgreementModal(true))),
          onOnClose: _cache[7] || (_cache[7] = ($event: any) => (onCloseServiceAgreementModal(false)))
        }, null, 8, ["project", "projectEstimate"]))
      : _createCommentVNode("", true)
  ]))
}
}

})